"use client";
import { useAuiState } from "@assistant-ui/store";
export const useMessagePartText = () => {
    const text = useAuiState(({ part }) => {
        if (part.type !== "text" && part.type !== "reasoning")
            throw new Error("MessagePartText can only be used inside text or reasoning message parts.");
        return part;
    });
    return text;
};
//# sourceMappingURL=useMessagePartText.js.map